import "./index.css";
import {
  Button,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import {COLORS} from "../colors/color";
import { useTranslation } from "react-i18next";

export default function ArrayInput({ value, onChange }) {

  const {t}=useTranslation();
  const handleChange = (index, newValue) => {
    const newArray = [...value];
    newArray[index] = newValue;
    onChange(newArray);
  };

  const handleAdd = () => {
    if (value.map((item, index) => value.item != "")) {
      console.log("Array Of string value ", value);
      onChange([...value, ""]);
    }
  };

  const handleRemove = (index) => {
    const newArray = [...value];
    newArray.splice(index, 1);
    onChange(newArray);
  };

  return (
    <div>
      {value.map((item, index) => (
        <div key={index}>
          <TextField
            value={item}
            onChange={(e) => handleChange(index, e.target.value)}
            sx={{marginBottom: '10px', marginRight: '10px'}}
          >

          </TextField>
          <Button
            color="primary"
            variant="contained"
            sx={{
              bgcolor: COLORS.signIn,
              ":hover": {
                bgcolor: COLORS.grey,
              },
              marginTop: '10px'
            }}
            onClick={() => handleRemove(index)}
          >
            {t("cardPost.remove")}
          </Button>
        </div>
      ))}
      <Button
        color="primary"
        variant="contained"
        sx={{
          bgcolor: COLORS.signIn,
              ":hover": {
                bgcolor: COLORS.grey,
          },
        }}
        onClick={handleAdd}
      >
        {t("cardPost.addRequirement")}
      </Button>
    </div>
  );
}
